export const showAnalyticsContextKey = '__TIMELY_DEV__showAnalyticsContext';
export const pretendToBeNonMemoryUserKey = '__TIMELY_DEV__pretendToBeNonMemoryUser';
